import { render, staticRenderFns } from "./TemplateDataConfig.vue?vue&type=template&id=322c3a14&"
import script from "./TemplateDataConfig.vue?vue&type=script&lang=js&"
export * from "./TemplateDataConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports